namespace $.$$ {
	$mol_style_define($bog_testops_app, {})
}
